// @flow
import type { CarEntity, Car } from '../types';
import { TYPE } from '../constants/targetConstants';
import { getDataSource } from '../utils/targetUtils';
import makeTargetReducer from './_makeTargetReducer';
import type { State as TargetState } from './_makeTargetReducer';

export type State = TargetState<Car, CarEntity>;

export default makeTargetReducer({ type: TYPE.car, getDataSource });